import React, { Component } from 'react'
import AddNewTalentStep1 from './AddNewTalentStep1';
import AddNewTalentStep2 from './AddNewTalentStep2';
import { observer } from 'mobx-react';
import talentStore from '../../stores/voiceStore';
import { CompletedIcon, PieChartIcon } from '../../assets/icons'
import AddNewTalentStep3 from './AddNewTalentStep3';
import { FaTimes } from 'react-icons/fa'

const Modal = observer(class Modal extends Component {

  renderSteps = (step) => (
    <div className='flex relative flex-row w-full lg:w-1/2 z-10'>
      <button onClick={() => {
        talentStore.changeStepperVisible(false);
      }} className='absolute right-5 top-4'>
        <FaTimes size={20} color='black'></FaTimes>
      </button>
      <div className={`flex flex-1 flex-row gap-3 p-4 ${step === 1 ? "bg-white lg:flex" : "bg-[#EEEEEE]  hidden lg:flex"}`}>
        {
          step === 1 ? <img className='w-4 transition-all' src={PieChartIcon} alt='Pie Chart'/> : <img className='w-4 transition-all' src={CompletedIcon} alt='Completed' />
        }

        <div className='flex flex-col'>
          <span className='font-normal text-sm text-[#21272A]'>1. Personal Details</span>
          <span className='font-normal text-xs text-[#697077]'>
            {
              step === 1 ? "Active Step" : "Completed"
            }
          </span>
        </div>
      </div>

      <div className={`flex flex-1 flex-row gap-3 p-4 ${step === 2 ? "bg-white lg:flex" : "bg-[#EEEEEE] hidden lg:flex"}`}>

        {
          step <= 1 || step === 2 ? <img className='w-4 transition-all' src={PieChartIcon} alt='Pie Chart' /> : <img className='w-4 transition-all' src={CompletedIcon} alt='Completed'/>
        }
        <div className='flex flex-col'>
          <span className='font-normal text-sm text-[#21272A]'>2. Voice Uploads</span>
          <span className='font-normal text-xs text-[#697077]'>
            {
              step === 2 ? "Active Step" : step === 1 ? "Incomplete" : "Completed"
            }
          </span>
        </div>
      </div>

      <div className={`flex flex-1 flex-row gap-3 p-4 ${step === 3 ? "bg-white lg:flex" : "bg-[#EEEEEE] hidden lg:flex"}`}>
        <img className='w-4 transition-all' src={PieChartIcon}  alt='Pie Chart'/>
        <div className='flex flex-col'>
          <span className='font-normal text-sm text-[#21272A]'>3. Review Details</span>
          <span className='font-normal text-xs text-[#697077]'>
            {
              step === 3 ? "Active Step" : "Incomplete"
            }
          </span>
        </div>
      </div>
    </div>
  )

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  // handleKeyDown = (event) => {
  //   if (event.key === 'Escape') {
  //     talentStore.changeStepperVisible(false);
  //   }
  // };

  render() {
    const { step } = talentStore

    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50">
        {this.renderSteps(step)}

        <div className="flex flex-col overflow-scroll w-full lg:w-1/2 h-full lg:h-[85%]  py-6 px-5 lg:px-10 overflow-y-scroll overflow-x-hidden bg-white shadow-lg">
          {step === 1 && (
            <AddNewTalentStep1></AddNewTalentStep1>
          )}
          {step === 2 && (
            <AddNewTalentStep2></AddNewTalentStep2>
          )}
          {step === 3 && (
            <AddNewTalentStep3></AddNewTalentStep3>
          )}
        </div>
      </div>)
  }
}
)

export default Modal